const com = require("../common");
var component = require('@hcComponent');
const Prompt = require('../dialog/prompt');
const res = require('../res');
const cfg = res.cfg;
const Modal = require('../dialog/modal');

/**
 * 导出公共方法
 * @param config 参数配置，对象传参，可以自行配置
 */
export function exportCommon (config) {
    Modal.confirmRecord({
        title: config.title,
        content: config.content,
        okText: '下载',
        onOk: function () {
            var ms = Prompt.loading("正在下载，请稍后...");
            com.getJson({
                url: cfg.get('doExport'),
                type: 'post',
                contentType: 'application/json',
                data: JSON.stringify(config.param),
            }).done(res => {
                Modal.show({
                    title: '导出提示',
                    content: '文件导出请求发送成功，请点击左边“上传/下载”菜单进行下载。若未显示相应的文件下载，请耐心等候！',
                });
            }).fail(res => {
                Modal.show({
                    title: '导出提示',
                    content: '文件导出失败，'+(res != null && res.message!=undefined && res.message!=null
                        ? res.message:'请联系管理员！'),
                });
            }).always(function () {
                ms.destroy();
            });
        }.bind(this)
    });
}





// WEBPACK FOOTER //
// ./component/export/exportUtil.js